import LegendScoreTooltipContent from './LegendScoreTooltipContent';
import './LegendScoreTooltipContent.scss';

export default LegendScoreTooltipContent;
